import type QueuesDetailsData from "~~/api/response/data/queue/QueuesDetailsData";
import QueueDetails from "~/dto/queue/QueueDetails";
import QueuesCounts from "~/dto/queue/QueuesCounts";

export default class QueuesDetails {
  live: QueueDetails;
  priority: QueueDetails | null;

  constructor(data: QueuesDetailsData) {
    this.live = new QueueDetails(data.live);
    this.priority = data.priority ? new QueueDetails(data.priority) : null;
  }

  get counts() {
    return new QueuesCounts(this.live.count, this.priority?.count || null);
  }

  get items() {
    return (this.priority?.items || []).concat(this.live.items);
  }
}
